export default function ArticleContent({
    article,
}) {
    return (
        <article className="article-content">

            {article.excerpt && (
                <div className="article-content__intro">
                    {article.excerpt}
                </div>
            )}


            {article.content_a && (
                <div
                    className="article-content__body"
                    dangerouslySetInnerHTML={{
                        __html:
                            article.content_a,
                    }}
                />
            )}


            {article.content_b && (
                <div
                    className="article-content__body article-content__body--second"
                    dangerouslySetInnerHTML={{
                        __html:
                            article.content_b,
                    }}
                />
            )}


            {article.categories?.length > 0 && (
                <div className="article-content__categories">

                    <span>
                        دسته‌بندی:
                    </span>

                    <div>
                        {article.categories.map(
                            category => (
                                <span
                                    key={category.id}
                                    className="article-content__category"
                                >
                                    {category.title}
                                </span>
                            )
                        )}
                    </div>

                </div>
            )}

        </article>
    );
}